import {
    Box,
    Heading,
    SimpleGrid,
    Image,
    Text,
    Link,
    Container,
    Center,
    Dialog,
    IconButton,
    HStack,
    Spacer,
  } from "@chakra-ui/react"
  import { useState } from "react"
  import { FaTimes } from "react-icons/fa"
  import { FaPlus } from "react-icons/fa6"
  import { FiExternalLink } from "react-icons/fi";
  
  export default function Gallery() {
    const [selectedImage, setSelectedImage] = useState(null)
    const [dialogOpen, setDialogOpen] = useState(false)
  
    const imageList = Array.from({ length: 15 }, (_, i) => `/gallery-images/${i + 1}.png`)
  
    const openDialogWithImage = (src) => {
      setSelectedImage(src)
      setDialogOpen(true)
    }
  
    const closeDialog = () => {
      setDialogOpen(false)
      setSelectedImage(null)
    }
  
    return (
      <Box id="gallery" py={20}>
        <Container maxW="container.xl" px={{ base: 4, md: 8 }}>
          <Heading as="h2" size="5xl" fontWeight="medium" mb={2}>
            Gallery
          </Heading>
          <Text fontSize="lg" mb={10}>
            A glimpse of our stunning transformations and professional detailing work.
          </Text>
        </Container>
  
        <SimpleGrid
          columns={{ base: 1, sm: 2, md: 3, lg: 4 }}
          spacingX={6}
          spacingY={6}
          px={14}
        >
          {imageList.map((src, index) => (
            <Box
              key={index}
              width="100%"
              height="250px"
              overflow="hidden"
              borderRadius="md"
              padding={5}
              cursor="pointer"
              onClick={() => openDialogWithImage(src)}
            >
              <Image
                src={src}
                alt={`Gallery image ${index + 1}`}
                objectFit="cover"
                w="100%"
                h="100%"
                borderRadius="md"
                _hover={{ transform: "scale(1.05)", transition: "0.3s ease-in-out" }}
              />
            </Box>
          ))}
  
          {/* Final Grid Item: See More Button */}
          <Box
            overflow="hidden"
            borderRadius="md"
            borderLeft="1px solid #e0e0e0"
            borderRight="1px solid #e0e0e0"
            borderTop="1px solid #e0e0e0"
            margin={4.5}
            alignItems="center"
            justifyContent="center"
            className="instagramBottomBorder"
          >
            <Box h="100%" mt={7}>
              <Center h="100px" fontSize="6xl">
                <FaPlus />
              </Center>
              <Heading textAlign="center" fontSize={{ base: "md", md: "2xl"}} mb={{ base: 6, md: 0 }}>
                See more on our{" "}
                <Link href="https://www.instagram.com/chromadetail" color="blue.500" target="_blank">
                  Instagram <FiExternalLink />
                </Link>
              </Heading>
            </Box>
          </Box>
        </SimpleGrid>
  
        {/* Dialog Section */}
        <Dialog.Root open={dialogOpen} onClose={closeDialog} closeOnEscape={true} closeOnInteractOutside={true}>
          <Dialog.Backdrop onClick={closeDialog} />
  
          <Dialog.Positioner>
            <Dialog.Content maxW="5xl" borderRadius="lg" overflow="hidden" p={0} bg="white">
              {/* Header Section */}
              <Box p={4} borderBottom="1px solid #e2e8f0">
                <HStack>
                  <Heading size="md">Image Expansion</Heading>
                  <Spacer />
                  <Dialog.CloseTrigger asChild>
                    <IconButton
                      aria-label="Close"
                      size="sm"
                      onClick={closeDialog}
                    >
                        <FaTimes />
                        </IconButton>
                  </Dialog.CloseTrigger>
                </HStack>
              </Box>
  
              {/* Image Section */}
              {selectedImage && (
                <Image
                  src={selectedImage}
                  alt="Full view"
                  w="100%"
                  h="auto"
                  objectFit="contain"
                />
              )}
            </Dialog.Content>
          </Dialog.Positioner>
        </Dialog.Root>
      </Box>
    )
  }
  